import { render, staticRenderFns } from "./LookLessonDialog.vue?vue&type=template&id=94bfb014&scoped=true&"
import script from "./LookLessonDialog.vue?vue&type=script&lang=js&"
export * from "./LookLessonDialog.vue?vue&type=script&lang=js&"
import style0 from "./LookLessonDialog.vue?vue&type=style&index=0&id=94bfb014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bfb014",
  null
  
)

export default component.exports